"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var AsyncResult = /** @class */ (function () {
    function AsyncResult(value) {
        this.value = value;
    }
    /**
     * Gets the underlying promise, which can then be awaited to return a @see Result
     */
    AsyncResult.prototype.get = function () {
        return this.value;
    };
    /**
     * Maps the OK value to another value. Will only run if the value is OK.
     */
    AsyncResult.prototype.map = function (fn) {
        return AsyncResult.wrap(this.value.then(_1.Result.map(fn)));
    };
    /**
     * Maps the Error value back to an OK value. Will only run if the value is Error.
     */
    AsyncResult.prototype.mapError = function (fn) {
        return AsyncResult.wrap(this.get().then(_1.Result.mapError(fn)));
    };
    /**
     * Binds the OK value to the AsyncResult returned by the @param fn function. Will only run if the value is OK.
     */
    AsyncResult.prototype.bind = function (fn) {
        var _this = this;
        return AsyncResult.wrap(this.get()
            .then(function (result) { return __awaiter(_this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                if (result.isOk()) {
                    value = fn(result.getValue());
                    return [2 /*return*/, value];
                }
                return [2 /*return*/, AsyncResult.wrap(_1.Result.ofError(result.getError()))];
            });
        }); })
            .then(AsyncResult.get));
    };
    /**
     * Binds the Error value to the AsyncReuslt returned by the @param fn function. Will only run if the value is Error.
     */
    AsyncResult.prototype.bindError = function (fn) {
        var _this = this;
        return AsyncResult.wrap(this.get()
            .then(function (result) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (result.isError()) {
                    return [2 /*return*/, fn(result.getError())];
                }
                return [2 /*return*/, AsyncResult.wrap(result.getValue())];
            });
        }); })
            .then(AsyncResult.get));
    };
    /**
     * Passes the OK value to the given @param fn function. Will only run if the value is OK.
     */
    AsyncResult.prototype.iter = function (fn) {
        this.get().then(_1.Result.iter(fn));
        return this;
    };
    /**
     * Passes the Error value to the given @param fn function. Will only run if the value is Error.
     */
    AsyncResult.prototype.iterError = function (fn) {
        this.get().then(_1.Result.iterError(fn));
        return this;
    };
    /**
     * Wraps a value, promise or result in an AsyncResult monad.
     */
    AsyncResult.wrap = function (value) {
        if (value instanceof _1.Result) {
            return new AsyncResult(Promise.resolve(value));
        }
        if (value instanceof Promise) {
            return new AsyncResult(value
                .then(function (value) { return (value instanceof _1.Result ? value : _1.Result.ofValue(value)); })
                .catch(function (ex) { return _1.Result.ofError(ex); }));
        }
        return new AsyncResult(_1.Result.ofPromise(Promise.resolve(value)));
    };
    /**
     * Gets the underlying promise, which can then be awaited.
     */
    AsyncResult.get = function (a) {
        return a.get();
    };
    /**
     * Returns a curried function that will map the OK value to another value. Will only run if the value is OK.
     */
    AsyncResult.map = function (fn) {
        return function (a) { return a.map(fn); };
    };
    /**
     * Returns a curried function that will map the Error value back to an OK value. Will only run if the value is Error.
     */
    AsyncResult.mapError = function (fn) {
        return function (a) { return a.mapError(fn); };
    };
    /**
     * Returns a curried function that will bind the OK value to the AsyncResult returned by the @param fn function. Will only run if the value is OK.
     */
    AsyncResult.bind = function (fn) {
        return function (a) { return a.bind(fn); };
    };
    /**
     * Returns a curried function that will bind the Error value to the AsyncReuslt returned by the @param fn function. Will only run if the value is Error.
     */
    AsyncResult.bindError = function (fn) {
        return function (a) { return a.bindError(fn); };
    };
    /**
     * Returns a curried function that will pass the OK value to the given @param fn function. Will only run if the value is OK.
     */
    AsyncResult.iter = function (fn) {
        return function (a) { return a.iter(fn); };
    };
    /**
     * Returns a curried function that will pass the Error value to the given @param fn function. Will only run if the value is Error.
     */
    AsyncResult.iterError = function (fn) {
        return function (a) { return a.iterError(fn); };
    };
    return AsyncResult;
}());
exports.AsyncResult = AsyncResult;
//# sourceMappingURL=asyncresult.js.map